module.exports = "/images/vendor/dhtmlx-scheduler/codebase/imgs_dhx_material/clock_big.png?ba9156cf30954a2b2e705a17e09b6f07";